export function validarChaveNFe(chave: string): boolean {
    if (!/^\d{44}$/.test(chave)) {
        return false // Deve ter exatamente 44 dígitos numéricos
    }

    const pesos = [2, 3, 4, 5, 6, 7, 8, 9]
    let soma = 0
    let pesoIndex = 0

    // Calcula a soma ponderada dos 43 primeiros dígitos
    for (let i = 42; i >= 0; i--) {
        const digito = parseInt(chave[i], 10)
        soma += digito * pesos[pesoIndex]
        pesoIndex = (pesoIndex + 1) % pesos.length
    }

    const resto = soma % 11
    const digitoCalculado = resto === 0 || resto === 1 ? 0 : 11 - resto

    const digitoInformado = parseInt(chave[43], 10)
    return digitoCalculado === digitoInformado
}
